/**
 * Convert restaurant name to URL-friendly slug
 * Example: "BHC Chicken" -> "BHC-Chicken"
 * Example: "McDonald's" -> "McDonalds"
 */
export const toSlug = (name) => {
  if (!name) return "";
  return name
    .trim()
    .replace(/'/g, "") // Remove apostrophes
    .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters except spaces and hyphens
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, ""); // Remove leading/trailing hyphens
};

/**
 * Convert URL slug back to restaurant name
 * This is a best-effort conversion - we try to match common restaurant name patterns
 * Example: "BHC-Chicken" -> "BHC Chicken"
 *
 * Note: Since we can't perfectly reconstruct the original (e.g., apostrophes are lost),
 * we'll need to do a fuzzy match on the backend or use a lookup table
 */
export const fromSlug = (slug) => {
  if (!slug) return "";
  // Convert slug to title case
  return slug
    .split("-")
    .map((word) => {
      // Handle acronyms (all caps) like "BHC", "GSC"
      if (word.length <= 3 && word === word.toUpperCase()) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

/** Lowercase a-z/0-9 only — for matching slug-derived names to DB names with dots, apostrophes, etc. */
export const normalizeBrandNameForMatch = (name) =>
  String(name || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
